export default __webpack_public_path__ + "static/media/copy.4c19a6dd.svg";